import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, openContent } from '@nu-art/thunderstorm-frontend';
import { ICONS } from '@app/styles';
import { iconTooltipId } from '../../../_style/icon-tooltip/index.js';
import './Renderer_DecisionForkChip.scss';
const tooltipContent = 'Choose how this protocol should continue';
export const Renderer_DecisionForkChip = () => {
    return _jsxs(Button, { variant: 'primary', className: 'decision-fork-chip', ...openContent.tooltip.left(iconTooltipId, tooltipContent, { offset: 8 }), children: [_jsx(ICONS.advisor_avn_chevron.component, {}), "Resolve"] });
};
//# sourceMappingURL=Renderer_DecisionForkChip.js.map